import { REPORT_COMPONENT_TYPES } from '@sonar-software/sonar-ts-constants';

const reportComponentTypeMap: Record<string, string> = {
	aggregateColumn: REPORT_COMPONENT_TYPES.AGGREGATE_COLUMN,
	column: REPORT_COMPONENT_TYPES.COLUMN,
	crossFilter: REPORT_COMPONENT_TYPES.CROSS_FILTER,
	crossFilterCriterion: REPORT_COMPONENT_TYPES.CROSS_FILTER_CRITERIA,
	customDetailFormula: REPORT_COMPONENT_TYPES.CUSTOM_DETAIL_FORMULA,
	customSummaryFormula: REPORT_COMPONENT_TYPES.CUSTOM_SUMMARY_FORMULA,
	filter: REPORT_COMPONENT_TYPES.FILTER,
	grouping: REPORT_COMPONENT_TYPES.GROUPING
};

export function mapReportComponentType(componentType: string | null | undefined): string | null | undefined {
	if (!componentType) {
		return componentType;
	}

	return reportComponentTypeMap[ componentType ] ?? componentType;
}
